import React, { useState, useEffect, useContext, Fragment, useRef, useMemo } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
//import PdfViewer from 'components/pdf/pdfViewer';
import StatusBar from '@components/StatusBar';
import { IcoUploadFile, CloudArrowDown, IcoCanc, Eye, EyeSlash } from '@icons';
import { Spinner } from 'react-bootstrap';
import {
	getOeDocuments,
	uploadDocument,
	getDocuments,
	downloadDocument,
	deleteDocument,
	documentPreview,
	uploadDocumentByDocumentId,
	getNoticesDocumentsOfProject,
} from '@lib/api';
import OEIframePreview from 'components/oeiframepreview/OEIframePreview';
import { translate } from 'components/translation/translation';
import { determineMimeType } from 'utils/determineMimeType';
import { UserContext } from 'components/contexts/UserProvider';
import { sortByNameWithNumbers } from 'lib/helpers/ordering';

const UploadDocument = ({
	entity,
	TitleButton = <></>,
	entityId,
	projectId = undefined,
	filterBySection = undefined,
	groupedBySection = false,
	disableDelete = false,
	disableEdit = false,
	externalBorder = false,
	enableUpload = false,
	// isValidated = false,
	displayName = false,
	title = 'Documenti',
	wpCompanyManagement = null,
	noticeId = null,
}) => {
	const { userAccess } = useContext(UserContext);
	const [isPending, setIsPending] = useState(false);
	const [oeDocuments, setOeDocuments] = useState([]);
	const [sections, setSections] = useState([]);
	const [counter, setCounter] = useState({});
	const [uploadedDocuments, setUploadedDocuments] = useState([]);
	const [sbShow, setSbShow] = useState(<></>);
	const [previewMode, setPreviewMode] = useState(false);
	//const [previewUrl, setPreviewUrl] = useState('');
	const [previewBlob, setPreviewBlob] = useState(null);
	const [previewMimeType, setPreviewMimeType] = useState(null);
	const [selectedDocument, setSelectedDocument] = useState(null);
	const [selectedCompanyId, setSelectedCompanyId] = useState(null);
	const fileInputRef = useRef([]);
	const companiesList = useMemo(() => {
		if (wpCompanyManagement && !wpCompanyManagement.isBeneficiary) {
			const uniqueNames = new Map();

			uploadedDocuments
				.flatMap((doc) => doc.companyOwners)
				.forEach((owner) => {
					if (!uniqueNames.has(owner.id)) {
						uniqueNames.set(owner.id, { id: owner.id, name: owner.name });
					}
				});

			return Array.from(uniqueNames.values());
		}
	}, [wpCompanyManagement, uploadedDocuments]);
	//console.log('oeDocuments', oeDocuments);
	//console.log('filterBySection', filterBySection);

	useEffect(() => {
		async function fetchOeDocuments() {
			let oeDocuments;

			if (noticeId) {
				oeDocuments = await getNoticesDocumentsOfProject(noticeId);
			} else {
				oeDocuments = await getOeDocuments(entity, entity === 'timesheets' ? projectId : '');
			}

			if (oeDocuments.success === true) {
				oeDocuments = noticeId ? oeDocuments.data.associated.filter((doc) => !doc.deleted) : oeDocuments.data.filter((doc) => !doc.deleted);

				if (filterBySection) {
					setOeDocuments(
						oeDocuments
							.filter((oeDoc) => {
								return filterBySection.some((filter) => {
									return oeDoc.section === filter;
								});
							})
							.sort((a, b) => a.position - b.position),
					);
				} else {
					if (groupedBySection) {
						let tempSections = oeDocuments
							.sort((a, b) => (a.sectionPosition ? a.sectionPosition - b.sectionPosition : a.section - b.section))
							.map((el) => el.section);
						tempSections = tempSections.filter((item, index) => tempSections.indexOf(item) === index);

						setSections(tempSections);
					}

					// Check if the data is an object or an array
					if (Array.isArray(oeDocuments)) {
						setOeDocuments(oeDocuments.sort((a, b) => a.position - b.position));
					} else {
						// Convert the object into an array
						const oeDocumentsArray = Object.values(oeDocuments);
						setOeDocuments(oeDocumentsArray.sort((a, b) => a.position - b.position));
					}
				}
			}
		}

		fetchOeDocuments();
	}, [entity, filterBySection, groupedBySection, projectId, noticeId]);

	useEffect(() => {
		if (entityId) {
			getUploadedDocuments();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [entityId]);

	const getUploadedDocuments = () => {
		getDocuments(entity, entityId).then((documents) => {
			if (documents.success === true) {
				const counter = new Map();

				documents.data.forEach(({ documentCode, missing }) => {
					if (missing !== undefined && !missing) {
						counter.set(documentCode, (counter.get(documentCode) || 0) + 1);
					}
				});

				const counterObject = Object.fromEntries(counter);
				setCounter(counterObject);

				let tempUploadedDocuments = [...documents.data];

				if (wpCompanyManagement && wpCompanyManagement.isBeneficiary) {
					tempUploadedDocuments = tempUploadedDocuments.filter((doc) =>
						doc.companyOwners.some((owner) => wpCompanyManagement.filterDocsByUserCompanyIds?.includes(owner.id)),
					);
				}

				setUploadedDocuments(tempUploadedDocuments);
			}
		});
	};

	const handleStatusBar = (status, message, timeout) => {
		setSbShow(<StatusBar status={status} message={message} timeout={timeout} />);
	};

	const handleUploadDocument = async (event, index, document) => {
		const code = document.code;
		const entityType = document.entityType;
		let matchMissingFile = null;
		let id = null;
		const curDoc = uploadedDocuments.filter((item) => item.documentCode === document.code).shift();
		if (curDoc && curDoc.missing) {
			matchMissingFile = curDoc.missing;
			id = curDoc.id;
		}
		//console.log(matchMissingFile, id);
		setSbShow(<></>);
		//console.log(event.target.files);
		const files = [...event.target.files];
		//console.log('files', files);
		const file = event.target.files[0];
		//console.log('files', files);
		event.target.value = null;
		//console.log('files', files);
		setIsPending(true);

		try {
			// UPLOAD
			//console.log(file)
			if (file.size > 200000000) {
				handleStatusBar('error', translate('common.error.filecannotexceed200', 'Il file non può superare i 200MB'), true);
				setIsPending(false);
				return false;
			}

			//console.log('o', files);
			let uploadPromise = [];

			if (wpCompanyManagement) {
				files.forEach((file) => {
					wpCompanyManagement.filterDocsByUserCompanyIds?.forEach((companyId) => {
						uploadPromise.push(uploadDocument(entityType, entityId, code, file, matchMissingFile, id, companyId));
					});
				});
			} else {
				files.forEach((file) => {
					uploadPromise.push(uploadDocument(entityType, entityId, code, file, matchMissingFile, id));
				});
			}

			const result = await Promise.allSettled(uploadPromise);
			let errorMessage = [];
			let message = [];

			result.forEach((item) => {
				if (item.status === 'rejected') {
					//console.log('item', item);
					errorMessage.push(item.reason.message);
				}
				if (item.status === 'fulfilled') {
					message.push(item);
				}
			});

			//console.log('errorMessage', errorMessage);
			//console.log('message', message);

			if (errorMessage.length > 0) {
				handleStatusBar('error', errorMessage.join(', '), true);
				setIsPending(false);
			}

			if (message.length > 0) {
				let messages = [];

				if (message.some((el) => el.value.success === false)) {
					messages = message.map((el) => el.value.message);
					handleStatusBar('error', messages.join(', '), true);
					setIsPending(false);
				} else {
					messages = message.map((el) => el.value.message);
					handleStatusBar('success', messages.join(', '), true);
					setIsPending(false);
				}
			}

			getUploadedDocuments();
		} catch (error) {
			setIsPending(false);
			console.log(error);
		}
	};

	const handleUploadSubDocument = async (e, documentId) => {
		setSbShow(<></>);

		const file = e.target.files[0]; // Prende solo il primo file

		setIsPending(true);

		if (!file || !documentId) {
			setIsPending(false);
			return;
		}

		e.target.value = null;

		try {
			// Controllo della dimensione del file
			if (file && file.size > 200000000) {
				handleStatusBar('error', 'File troppo grande (massimo consentito: 200MB)', true);
				setIsPending(false);
				return false;
			}

			const result = await uploadDocumentByDocumentId(documentId, file, selectedCompanyId);

			if (result) {
				handleStatusBar('success', 'File caricato con successo', true);
			} else {
				handleStatusBar('error', 'Errore nel caricamento del file', true);
			}

			getUploadedDocuments();
		} catch (error) {
			console.error(error);
			handleStatusBar('error', 'Si è verificato un errore', true);
		} finally {
			setSelectedDocument(null);
		}

		setIsPending(false);
	};

	const handleDownload = async (event, upDocument) => {
		setSbShow(<></>);
		setIsPending(true);

		try {
			// UPLOAD
			const result = await downloadDocument(upDocument);

			if (result.success) {
				// File upload successful
				handleStatusBar('success', 'Documento scaricato con successo', true);
				setIsPending(false);
			} else {
				const message = result.data.file.join(',');
				handleStatusBar('error', message, false);
				setIsPending(false);
			}
		} catch (error) {}
	};

	const handleDelete = async (event, upDocument) => {
		setSbShow(<></>);
		setIsPending(true);

		try {
			const result = await deleteDocument(upDocument);

			if (result.success) {
				handleStatusBar('success', 'Documento eliminato con successo', true);

				//const newList = uploadedDocuments.filter((item) => item.id !== upDocument.id);
				//setUploadedDocuments(newList);
			} else {
				const message = result.data.file.join(',');
				handleStatusBar('error', message, false);
			}

			setIsPending(false);
			getUploadedDocuments();
		} catch (error) {}
	};

	const handlePreview = async (event, upDocument) => {
		//console.log("upDocument", upDocument);
		setPreviewBlob(null);
		setSbShow(<></>);
		setIsPending(true);
		setPreviewMode(true);
		const response = await documentPreview(upDocument);
		const blob = await response;
		setPreviewBlob(blob);
		setPreviewMimeType(determineMimeType(upDocument));
		setIsPending(false);
	};

	const docRows = (uplDocs, document, companyId) => {
		//console.log('uplDocs', uplDocs);

		return sortByNameWithNumbers(uplDocs, 'description').map((upDocument, index) =>
			upDocument.documentCode === document.code ? (
				<Fragment key={`docs-${index}_${document.code}_${entityId}`}>
					<li className="d-flex justify-content-between">
						<Col className="col-12 mb-1">
							{enableUpload &&
								//  && !isValidated
								upDocument.missing && (
									<span>
										<span style={{ margin: '8px' }} />

										<IcoUploadFile
											style={{ cursor: 'pointer' }}
											onClick={(e) => {
												setSelectedDocument(upDocument);
												if (companyId) setSelectedCompanyId(companyId);

												e.stopPropagation(); // Impedisce la propagazione dell'evento
												if (!isPending && fileInputRef.current[index]) {
													fileInputRef.current[index].click();
												}
											}}
											className={`ico-small download-upload align-bottom ${isPending ? 'ico-disabled' : 'second-color'}`}
										/>

										<Form.Control
											type="file"
											ref={(el) => (fileInputRef.current[index] = el)} // Assegna il ref all'input
											disabled={isPending}
											style={{ display: 'none' }}
											onChange={(e) => {
												if (fileInputRef.current[index]) {
													fileInputRef.current[index].focus(); // Focalizza l'elemento corrispondente
												}
												handleUploadSubDocument(e, selectedDocument.id);
											}}
										/>
									</span>
								)}
							{!upDocument.missing && (
								<span>
									<span style={{ margin: '8px' }} />
									<Eye
										className={`ico-small download-upload ${
											isPending || upDocument.fileExtension === 'zip' || upDocument.fileExtension === '7z' ? 'ico-disabled' : 'ico-enabled'
										}`}
										{...(upDocument.fileExtension === 'zip' || upDocument.fileExtension === '7z'
											? {}
											: {
													onClick: (e) => handlePreview(e, upDocument),
												})}
									/>
									<span style={{ margin: '8px' }} />
									<CloudArrowDown
										style={{
											cursor: 'pointer',
											fill: '#09A8B0',
										}}
										className={isPending ? 'ico-disabled ico-small download-upload' : 'second-color ico-small download-upload'}
										onClick={(e) => handleDownload(e, upDocument)}
									/>
									<span style={{ margin: '8px' }} />
									{userAccess.isPartner && !disableDelete && (
										<IcoCanc
											style={{
												cursor:
													// isValidated ? 'default' :
													'pointer',
												viewBox: '0 0 24 24',
												fill:
													// isValidated ? '#99C5C8' :
													'#09A8B0',
												transform: 'translate(0, -1px)',
												marginRight: '15px',
												width: '24px',
												height: '24px',
											}}
											className={
												isPending
													? // || isValidated
														'disabled ico-small download-upload'
													: 'second-color ico-small download-upload'
											}
											onClick={(e) =>
												//  !isValidated &&
												handleDelete(e, upDocument)
											}
										/>
									)}
								</span>
							)}
							{/* Nome del file */}
							<span className="ms-2">
								{displayName && upDocument.name && (
									<>
										<strong>{upDocument.name}</strong> {' | '}
									</>
								)}
								{upDocument.missing && upDocument.description ? upDocument.description : upDocument.fileName}
							</span>

							{/* Badge per file mancante */}
							{upDocument.missing !== undefined && upDocument.missing && <span className="badge bg-danger ms-2">File mancante</span>}
						</Col>
					</li>
				</Fragment>
			) : null,
		);
	};

	const showDocumentList = (section) => {
		const tempDocuments = section ? oeDocuments.filter((doc) => doc.section === section) : oeDocuments;

		return tempDocuments.map((document, index) => (
			<Col key={`oedoc-${index}_${entityId}`} sm={12}>
				<Form.Group as={Col} className="px-3 mb-4" controlId={`${document.code}_${document.entityType}_${entityId}`}>
					<span className="me-1">
						{disableEdit ? null : userAccess.isPartner || userAccess.isGuestEnteErogante ? (
							<>
								<span className="required-field position-relative">
									<Form.Label>
										<IcoUploadFile
											style={{
												cursor: 'pointer',
											}}
											className={`ico-small download-upload align-bottom ${
												isPending ||
												// || isValidated
												(wpCompanyManagement && !wpCompanyManagement.isBeneficiary && !wpCompanyManagement.isCoordinator)
													? 'ico-disabled'
													: 'second-color'
											}`}
										/>
									</Form.Label>
									<Form.Control
										type="file"
										disabled={
											isPending ||
											// isValidated ||
											(wpCompanyManagement && !wpCompanyManagement.isBeneficiary && !wpCompanyManagement.isCoordinator)
												? true
												: false
										}
										style={{ display: 'none' }}
										multiple
										onChange={(e) => handleUploadDocument(e, index, document)}
									/>
								</span>
								&nbsp;
							</>
						) : null}
						{document.name}
						&nbsp;
						<span
							className={
								counter[document.code] < document.min || counter[document.code] === undefined
									? 'danger'
									: 'required-field position-relative'
							}
						>
							{/* {document.min > 0 ? 
               (counter[document.code] === undefined ? 
                  0 + "/" + document.min : counter[document.code] + "/" + document.min)
                : ""} */}
							{document.min > 0 ? <span className="ps-1">min. {document.min}</span> : ''}
						</span>
					</span>
					<ol className="ps-3">
						{wpCompanyManagement && !wpCompanyManagement.isBeneficiary && companiesList.length > 1
							? sortByNameWithNumbers(companiesList, 'name').map((company, index) => {
									const filteredUploadedDocuments = uploadedDocuments.filter((doc) =>
										doc.companyOwners.some((owner) => owner.id === company.id),
									);
									//console.log('filteredUploadedDocuments', filteredUploadedDocuments);
									return (
										<Fragment key={`company-${index}`}>
											{filteredUploadedDocuments.length && filteredUploadedDocuments.some((doc) => doc.documentCode === document.code) ? (
												<li className={`d-flex justify-content-between ${index ? 'mt-2' : ''}`}>
													<Col className="col-12 mb-1">
														<span>
															<span className="ms-3">{company.name}</span>
														</span>
													</Col>
												</li>
											) : null}
											{docRows(filteredUploadedDocuments, document, company.id)}
										</Fragment>
									);
								})
							: docRows(uploadedDocuments, document)}
					</ol>
				</Form.Group>
			</Col>
		));
	};

	return (
		<>
			{previewMode && (
				<div style={{ height: '95%', width: '100%' }}>
					<EyeSlash
						style={{ cursor: 'pointer', fill: '#09A8B0' }}
						className={`ico-small download-upload ${isPending ? 'ico-disabled' : 'second-color'}`}
						onClick={(e) => setPreviewMode(false)}
					/>
					<OEIframePreview blob={previewBlob} mimeType={previewMimeType} />
				</div>
			)}
			{!previewMode && (
				<Form key={`key-upload-docs-${entityId}`} id={`form-upload-docs-${entityId}`}>
					<Row>
						{/* {isPending && <Spinner animation="border" role="status" style={{display:'flex',margin:'0 auto'}}></Spinner>}  */}
						<Col className={`col-12 ${!externalBorder ? '' : 'border-tab right'}`}>
							<Row>
								{sbShow}

								{isPending && <Spinner animation="border" role="status" style={{ display: 'flex', margin: '0 auto' }}></Spinner>}

								{groupedBySection ? (
									sections.map((section) => {
										return (
											<Fragment key={section}>
												{section && <span className="mb-2rem">{section}</span>}

												{showDocumentList(section)}
											</Fragment>
										);
									})
								) : (
									<Col>
										<Row className="align-items-center justify-content-start mb-2rem gap-2">
											{title && <Form.Label className="w-auto mb-0">{title}</Form.Label>}
											{TitleButton &&
												React.cloneElement(TitleButton, {
													disabled: !uploadedDocuments.length || uploadedDocuments.every((doc) => doc.missing),
												})}
										</Row>
										<Row>{showDocumentList()}</Row>
									</Col>
								)}
							</Row>
						</Col>

						{false && (
							<Col className="col-6 py-3 text-center text-muted">
								{/* <PdfViewer pdfUrl='/Users/valeriomantini/Downloads/dummy.pdf' /> */}
							</Col>
						)}
					</Row>
				</Form>
			)}
		</>
	);
};

export default UploadDocument;
